module.exports = __webpack_public_path__ + "img/fitted-mask-loops-default.ab27b196.jpg";